module.exports = {
  i18n: {
    compatibilityJSON: 'v3',
    locales: ['default', 'en', 'de', 'fr', 'es'],
    defaultLocale: 'default',
    defaultNS: 'index',
    localeDetection: false,
    // debug: true - only for testing
    debug: false,
    ns: ['index'],
  },
  serializeConfig: false,
  // https://www.i18next.com/misc/creating-own-plugins
  use: [
    {
      type: 'backend',
      read: (locale, namespace, callback) => {
        try {
          const merge = require('lodash/merge');
          const local = require(`./public/locales/${locale}/${namespace}.json`);
          const core = require(`@Hotels-at-Home/hah-fe-core/locales/${locale}/${namespace}.json`);
          // Merge core and local translations
          const translation = merge({}, core, local);
          callback(null, translation);
        } catch (e) {
          callback('Error getting locales');
        }
      },
    },
  ],
};
